(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cervo-content"] && !Shopify.designMode) return;
  try {
    
  /* simple dots + prev/next that work with Dawn's native slider */
  (function() {
    const root = document.getElementById('shopify-section-{{ section.id }}');
    if (!root) return;

    const ul = root.querySelector('#Slider-{{ section.id }}');
    const dotsWrap = root.querySelector('#Dots-{{ section.id }}');
    const prevBtn = root.querySelector('.slider-button--prev');
    const nextBtn = root.querySelector('.slider-button--next');
    if (!ul) return;

    const slides = Array.from(ul.querySelectorAll('.slider__slide'));
    let index = 0;

    function clamp(n){ return Math.max(0, Math.min(n, slides.length-1)); }
    function goTo(i){
      index = clamp(i);
      const target = slides[index];
      ul.scrollTo({ left: target.offsetLeft - ul.offsetLeft, behavior: 'smooth' });
      updateDots();
      const comp = ul.closest('slider-component');
      if (comp && typeof comp.setSlidePosition === 'function') comp.setSlidePosition();
    }
    function updateDots(){
      if (!dotsWrap) return;
      Array.from(dotsWrap.children).forEach((d, i) => d.setAttribute('aria-current', i === index ? 'true' : 'false'));
    }

    if (dotsWrap && slides.length > 1){
      dotsWrap.innerHTML = '';
      slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.className = 'slider-dot';
        b.type = 'button';
        b.setAttribute('aria-label', `Go to slide ${i+1}`);
        b.addEventListener('click', () => goTo(i));
        dotsWrap.appendChild(b);
      });
    }

    prevBtn && prevBtn.addEventListener('click', () => goTo(index - 1));
    nextBtn && nextBtn.addEventListener('click', () => goTo(index + 1));

    // keep dots in sync on swipe
    ul.addEventListener('scroll', () => {
      const w = ul.clientWidth || 1;
      const newIndex = Math.round(ul.scrollLeft / w);
      if (newIndex !== index){
        index = clamp(newIndex);
        updateDots();
      }
    }, { passive: true });

    // init
    goTo(0);

    // re-run in Theme Editor interactions
    document.addEventListener('shopify:section:load', (e) => {
      if (e.target && e.target.id === root.id) goTo(0);
    });
  })();

  /* NEW: Only one accordion open at a time (per slide/frame) */
  (function(){
    const root = document.getElementById('shopify-section-{{ section.id }}');
    if (!root) return;

    function bindExclusive(scope){
      // Scope to each .cc-frame so each slide (or static frame) is its own group
      const frames = scope.querySelectorAll('.cc-frame');
      frames.forEach(frame => {
        const items = Array.from(frame.querySelectorAll('.accordion details'));
        // Early exit if fewer than 2
        if (items.length < 2) return;

        items.forEach(d => {
          // On any toggle to open, close all siblings
          d.addEventListener('toggle', () => {
            if (!d.open) return;
            items.forEach(other => {
              if (other !== d && other.open) other.removeAttribute('open');
            });
          });
        });
      });
    }

    // Initial bind
    bindExclusive(root);

    // Re-bind when section is reloaded in Theme Editor
    document.addEventListener('shopify:section:load', (e) => {
      if (e.target && e.target.id === root.id){
        bindExclusive(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
